import { PositionType } from '../../../lib/defs/types';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { IEffect } from './IEffect';
import { waitAFrame } from '../../../lib/util/waitAFrame';
import { StarGlareAnimation } from '../../animations/StarGlareAnimation';

// types
//-----------------------------------------------------------------------------
export type StarGlareEffectOptions = {
  position: PositionType;
};

/*
    chest breaking effect
*/
export class StarGlareEffect implements IEffect {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _position: PositionType;

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, options: StarGlareEffectOptions) {
    this._scene = scene;
    this._position = options.position;
  }

  public static assets(): string[] {
    return [];
  }

  // impl
  //-------------------------------------------------------------------------
  public async execute() {
    // wait a frame since we async the animation
    await waitAFrame();

    // animate
    this._animate();
  }

  // private: animation
  //-------------------------------------------------------------------------
  private async _animate() {
    // create  animation
    const animation = new StarGlareAnimation();
    // spawn animation as overlay
    const entity = spawnOverlayEntity(
      this._scene,
      this._position,
      {},
      () => animation,
    );
    // run animation
    await animation.start();
    // despawn entity
    despawnOverlayEntity(this._scene, entity);
  }
}
